import TagManager from "react-gtm-module";
import { dispatchSlice } from "components/hooks/dispatchSlice";
import { useSlice } from "components/hooks/useSlice";
import { getConfig } from "data/slices/config";

export function Analytics() {
  dispatchSlice(getConfig);

  const hostname = window.location.hostname;
  const isLocalDev = !!hostname.match(/localhost$/);
  const { tagManagerId: gtmId } = useSlice("config");

  if (!isLocalDev && gtmId) {
    TagManager.initialize({ gtmId });
  }

  return null;
}
